export default [
    {
        name: 'Airline',
        value: 's_airline'
    },
    {
        name: 'Misc Type',
        value: 's_misc_type'
    },
    {
        name: 'Date',
        value: 'd_flight',
        date: true,
        utc: true
    },
    {
        name: 'Validated',
        value: 'b_validated',
        boolean: true
    },
    {
        name: 'Created Date',
        value: 't_created',
        datetime: true,
        utc: true
    },
];